import { Link } from "react-router-dom";


export const ErrorMessage = ({ message, link = null }) => {
    return (
        <div className="no_data">
            <div className="bg">
                <img src={`${process.env.PUBLIC_URL}/static/images/recommend/recommend_noData.png`} alt="1~6학년만 맞춤 추천 됩니다!" />
                <div className="guide visible">
                    {link === null && <div className="text" dangerouslySetInnerHTML={{ __html: message }}></div>}
                    {link != null && <Link to={link}><div className="text" dangerouslySetInnerHTML={{ __html: message }}></div></Link>}
                    <div className="deco"></div>
                </div>
            </div>
        </div>
    );
}